/**
 * Texts for Training page
 */
export const trainingPageText = {
    title: 'Training - CamAPS FX',
    titleMeta: 'We provide free online training for CamAPS FX users',
    descriptionMeta: 'Cambridge Diabetes Education Programme hosts free online certified training for poeple with type 1 diabetes, parents and guardians,  school staf and helath care professionals.',
    keywords: 'camaps training, camaps fx training,  ',
    localeMeta: 'en_gb',
    mainHeader: 'HCP training',
    mainSubHeader: 'Support people using CamAPS FX with expert-led training.',
    gettingStartedHeader: 'Getting started',
    step1Title: '<strong>Step 1:</strong><br/>Download the app',
    step2Title: '<strong>Step 2:</strong><br/>Create an account',
    step3Title: '<strong>Step 3:</strong><br/>Begin the in-app essential training',
    step4Title: '<strong>Step 4:</strong><br/>Pair with your chosen pump and CGM (with the approval of your healthcare team) or explore the app with <strong>Virtual Mode</strong>',
    videoSrc: '/video/In-app training loop_1.mp4',
    certifiedTrainingTitle: 'Certified training for HCPs',
    trainingHeader: 'Certified training',
    trainingHeader_2: 'For healthcare professionals',
    trainingHeader_3: 'User training',
    trainingHeaderText: 'FREE online CamAPS FX training provided by the Cambridge Diabetes Education Programme (CDEP).',
    websiteLink: 'https://www.camdiabtraining.com/account-sign-in.html',
    websiteLinkHeading: 'CDEP training',
    getTrained: 'Get trained',
    trainingHeaderIat: 'CamAPS FX training',
    trainingHeaderTextIat: 'Complete the essential in-app training before using the CamAPS FX app.',
    trainingSubHeaderOneIat: 'Getting Started',
    trainingSubTextOneIat: 'Download the CamAPS FX app. <br>Create an account to begin training.',
    trainingSubHeaderTwoIat: 'Need help installing the app?',
    trainingParaTwoStartIat: 'Visit our',
    trainingParaTwoEndIat: 'section for guidance.',
    websiteLinkHeadingSupportIat: 'Support',
    trainingSubHeaderThreeIat: 'Additional Resources',
    animationsYpsoPumpText: 'Animations',
    animationsAndText: 'and',
    animationsDanaText: 'Animations (Dana pump)',
    animationsFurtherText: 'Learn through step-by-step visuals.',
    webinarsText: 'Webinars',
    webinarsFurtherText: 'Watch expert-led sessions on using the app.',
    websiteAnimationsYpsoPumpLink: 'https://www.camdiabtraining.com/view/27/mylife-YpsoPump-users.htm',
    websiteAnimationsDanaLink: 'https://www.camdiabtraining.com/view/25/Dana-insulin-pump-users.htm',
    websiteWebinarsLink: 'https://www.camdiabtraining.com/view/20/Webinars.htm',
};
